import React, { useEffect, useState } from 'react'
import { Form } from 'react-final-form'
import Header from '../components/Header/Header'
import { useSearchPaymentFormMutation } from '../../../services'
import { UspConfigurationPaymentFormViewResult } from '../../../models'
import PaymentPaymentsFormTable from './components/PaymentPaymentsFormTable'
import AddEditPaymentFormModal from './components/AddEditPaymentFormModal'
import { Button, Card, Container, Grid } from '@mui/material'
import CustomBreadcrumbs from '../../../components/custom-breadcrumbs/custom-breadcrumbs'
import Iconify from '../../../components/iconify'

const SettingsPaymentPaymentsForm = () => {
  const [rowData, setRowData] = useState({})
  const [openAddEditModal, setOpenAddEditModal] = useState(false)
  const [type, setType] = useState('')
  const [searchPaymentForm, { data, isLoading }] = useSearchPaymentFormMutation()
  const [paymentFormData, setPaymentFormData] = useState<UspConfigurationPaymentFormViewResult[]>([])

  const handleSubmit = (values?: any) => {
    searchPaymentForm({
      simpleSearch: {
        searchString: values?.searhString,
        isIncludeInactive: values?.isIncludeInactive,
      },
    })
  }

  const handleOpenModal = () => {
    setOpenAddEditModal(true)
    setType('add')
  }

  const handleCloseModal = () => {
    setOpenAddEditModal(false)
  }

  useEffect(() => {
    if (data) {
      setPaymentFormData(data)
    }
  }, [data])

  return (
    <Container>
      <CustomBreadcrumbs
        heading='Payment Form'
        links={[
          {
            name: 'List',
          },
        ]}
        action={
          <>
            <Button onClick={handleOpenModal} variant='contained' startIcon={<Iconify icon='mingcute:add-line' />}>
              Add new
            </Button>
          </>
        }
        sx={{
          mb: {
            xs: 3,
            md: 5,
          },
        }}
      />
      <Form onSubmit={handleSubmit} initialValues={{ searhString: null, isIncludeInactive: false }}>
        {({ handleSubmit, form: { submit } }: any) => (
          <>
            <form onSubmit={handleSubmit}>
              <Card>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Header submit={submit} title='' handleOpenModal={handleOpenModal} />
                  </Grid>
                  <Grid item xs={12}>
                    <PaymentPaymentsFormTable
                      setOpenAddEditModal={setOpenAddEditModal}
                      setType={setType}
                      setRowData={setRowData}
                      loading={isLoading}
                      data={paymentFormData}
                      setData={setPaymentFormData}
                    />
                  </Grid>
                </Grid>
              </Card>
            </form>
            <AddEditPaymentFormModal
              submit={submit}
              open={openAddEditModal}
              onClose={handleCloseModal}
              type={type}
              rowData={rowData as UspConfigurationPaymentFormViewResult}
            />
          </>
        )}
      </Form>
    </Container>
  )
}

export default SettingsPaymentPaymentsForm
